import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  Typography,
  Button,
  Divider,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { Colors } from "../../utils/constants";
import SourceType from "../../components/filterPopups/ModalOne";
import FilterSubject from "../../components/filterPopups/ModalTwo";
import FilterYear from "../../components/filterPopups/ModalThree";
import FilterCategory from "../../components/filterPopups/ModalOne";
// import FilterAuthor from "../../components/filterPopups/ModalTwoOfBrowseJournal";
import FilterSubjectOfBrowser from "../../components/filterPopups/ModalTwoOfBrowseJournal";
import FilterCountryOfPublication from "../../components/filterPopups/ModalTwoOfBrowseJournal";
import FilterL2SubjectOfBrowser from "../../components/filterPopups/ModalTwoOfPackageSubject";

import FilterSpeaker from "../../components/filterPopups/ModalTwo";
import FilterResearchGuide from "../../components/filterPopups/ModalTwo";
import FilterJournal from "../../components/filterPopups/ModalTwo";
import FilterRanking from "../../components/filterPopups/ModalOneOfBrowserJournal";
import FilterAuthor from "../../components/filterPopups/ModalOneOfBrowserJournal";
import FilterDataTypesOfJournalDetails from "../../components/filterPopups/ModalOneOfBrowserJournal";

import FilterCountry from "../../components/filterPopups/ModalTwoOfBrowseJournal";
import PublishingAuthor from "../../components/filterPopups/ModalTwo";
import FilterPublishers from "../../components/filterPopups/ModalTwo";
import FilterUniversity from "../../components/filterPopups/ModalTwo";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { getParamsByName, goToTop } from "../../utils/helper";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { updateSearchResults } from "../../store/slice/searchSlice";
import {
  updateSourceType,
  updateSubject,
  updateAuthor,
  updateSpeaker,
  updateResearch,
  updateJournal,
  updateSourceIndex,
  updateCountryOfPublication,
  updatePublisher,
  updateInstitution,
  updateJournalRank,
  updateCountryOfPublishingAuthor,
  clearAllFilters,
  updateOpenAccess,
  updateRetractedArticle,
  updateDateset,
  updateLoadingState,
  updateCurrentUpdate,
} from "../../store/slice/browserFilterSliceDetails";
import { ReducerObj } from "../../types/interface";
// import search from "../../screens/Search/onSearch";
import { useAppSelector } from "../../store/hooks";
import objectToQueryString from "../../screens/browseJournal/objToQuery";
import { usagelogApi } from "../../api/usageReportApi";
import { updateJournalDataType } from "../../store/slice/browseFilterSlice";

// Types

type YearType = { val: string; count: string };

interface PropType {
  yearFromData?: YearType[];
  jsonFacets?: any;
  from?: string;
}

const SearchFilterComponentOfJournalDetails = (props: any) => {
  // Props
  const { yearFromData, jsonFacets, setFilters, packageDetails, from } = props;

  console.log("props", props);

  const dispatch = useDispatch();
  const searchTerm = getParamsByName("searchterm");
  const selectedFilters: any = useSelector(
    (state: any) => state.browseFilterSlice,
  );

  const searchReducer: any = useSelector(
    (state: ReducerObj) => state.searchReducer,
  );

  const searchResults = useSelector((state: any) => state?.browserDetailsSlice);

  const searchResult = useSelector(
    (state: any) =>
      state?.browserDetailsSlice?.browserResult?.facets?.facet_fields,
  );

  const subject_l2_package_searchResult = useSelector(
    (state: any) =>
      state?.browserDetailsSlice?.browserResult?.jsonfacets?.subjects_name_l2,
  );

  const dataTypesOfJournalDetails = useSelector(
    (state: any) =>
      state?.browserDetailsSlice?.browserResult?.jsonfacets?.data_type,
  );

  const [sourceTypeModalStatus, setSourceTypeModalStatus] = useState(false);
  const [filterSubjectModalStatus, setFilterSubjectModalStatus] =
    useState(false);
  const [filterYearModalStatus, setFilterYearModalStatus] = useState(false);
  const [filterCategoryModalStatus, setFilterCategoryModalStatus] =
    useState(false);
  const [filterAuthorModalStatus, setFilterAuthorModalStatus] = useState(false);
  const [filterSpeakerModalStatus, setFilterSpeakerModalStatus] =
    useState(false);
  const [filterResearchModalStatus, setFilterResearchModalStatus] =
    useState(false);
  const [filterJournalModalStatus, setFilterJournalModalStatus] =
    useState(false);
  const [filterRankingModalStatus, setFilterRankingModalStatus] =
    useState(false);
  const [filterSourceModalStatus, setFilterSourceModalStatus] = useState(false);
  const [filterCountryModalStatus, setFilterCountryModalStatus] =
    useState(false);
  const [filterPublisherModalStatus, setFilterPublisherModalStatus] =
    useState(false);
  const [filterUnivModalStatus, setFilterUnivModalStatus] = useState(false);
  const [triggerCount, setTriggerCount] = useState<number>(0);
  const [copaModalStatus, setCopaModalStatus] = useState(false);
  const [filterL2SubjectModalStatus, setFilterL2SubjectModalStatus] =
    useState(false);

  const [filterDataTypeModalStatus, setFilterDataTypeModalStatus] =
    useState(false);

  // Applied filter values
  const sourceIndex = useSelector(
    (state: ReducerObj) => state.filterReducer.sourceIndex,
  );
  const openAccess = useAppSelector(
    (state) => state.browserDetailsSlice.currentUpdate,
  );

  const retractedArticle = useAppSelector(
    (state) => state.filterReducer.retractedArticle,
  );

  const datasetAvailability = useAppSelector(
    (state) => state.filterReducer.datesetAvailability,
  );
  const profileData = useAppSelector((state) => state.login);

  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  const is_ONOSCustomer = useSelector(
    (state: any) => state.customer.customerDetails?.is_enable_onos,
  );

  const toTitleCase = (value: string) => {
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const mergedData = (dataTypesOfJournalDetails?.buckets ?? []).reduce(
    (acc: any[], item: any) => {
      if (item.val === "journals" || item.val === "books series") {
        const existing = acc.find((obj) =>
          Object.prototype.hasOwnProperty.call(obj, "Journals"),
        );

        if (existing) {
          existing.Journals += item.count;
        } else {
          acc.push({
            Journals: item.count,
          });
        }
      } else {
        acc.push({
          [toTitleCase(item.val)]: item.count,
        });
      }

      return acc;
    },
    [],
  );

  const contextId =
    selectedFilters.collectionsValueJournal === "J-GateCollection"
      ? 1
      : selectedFilters.collectionsValueJournal === "Consortia Collections"
        ? 2
        : selectedFilters.collectionsValueJournal === "My Library Collections"
          ? 3
          : selectedFilters.collectionsValueJournal ===
              "MyPersonalLibraryCollection"
            ? 4
            : selectedFilters.collectionsValueJournal ===
                "Open Access Collections"
              ? 7
              : null;

  const logPackagesFiltersageData = (usageActionID: any, details?: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_Id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    const articleArticle_Id = details?.article_id ? details?.article_id : null;
    const articleResourcemaster_id = details?.resourcemaster_id
      ? details?.resourcemaster_id
      : null;
    const articleResourceissue_id = details?.resourceissue_id
      ? details?.resourceissue_id
      : null;
    const publisherId = details?.publisher_id ? details?.publisher_id[0] : null;
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_Id
        ? informaticscustomer_Id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const isONOS =
      is_ONOSCustomer &&
      selectedFilters.collectionsValueJournal === "ONOS Collections"
        ? 1
        : 0;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      articleArticle_Id,
      articleResourceissue_id,
      publisherId,
      articleResourcemaster_id,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      isONOS,
    );
  };

  useEffect(() => {
    if (triggerCount) applySearch();
  }, [triggerCount]);

  // Handle source type modal status changes
  const handleChangeSouceType = () => {
    setSourceTypeModalStatus(false);
  };

  // Handle Filter subject modal status changes
  const handleChangeFilterSubject = () => {
    setFilterSubjectModalStatus(false);
  };

  // Handle Filter subject modal status changes
  const handleChangeFilterL2Subject = () => {
    setFilterL2SubjectModalStatus(false);
  };

  // Handle Filter year modal status changes
  const handleChangeFilterYear = () => {
    setFilterYearModalStatus(false);
  };

  // Handle Filter category modal status changes
  const handleChangeFilterCategory = () => {
    setFilterCategoryModalStatus(false);
  };

  // Handle Filter Author modal status changes
  const handleChangeFilterAuthor = () => {
    setFilterAuthorModalStatus(false);
  };

  const handleChangeFilterDataType = () => {
    setFilterDataTypeModalStatus(false);
  };

  // Handle Filter speaker modal status changes
  const handleChangeFilterSpeaker = () => {
    setFilterSpeakerModalStatus(false);
  };

  // Handle Filter Research modal status changes
  const handleChangeFilterResearch = () => {
    setFilterResearchModalStatus(false);
  };

  // Handle Filter journal modal status changes
  const handleChangeFilterJournal = () => {
    setFilterJournalModalStatus(false);
  };

  // Handle Filter ranking modal status changes
  const handleChangeFilterRanking = () => {
    setFilterRankingModalStatus(false);
  };

  // Handle Filter source modal status changes
  const handleChangeFilterSource = () => {
    setFilterSourceModalStatus(false);
  };

  // Handle Filter country modal status changes
  const handleChangeFilterCountry = () => {
    setFilterCountryModalStatus(false);
  };

  // Handle Filter publisher modal status changes
  const handleChangeFilterPublisher = () => {
    setFilterPublisherModalStatus(false);
  };

  // Handle Filter univ modal status changes
  const handleChangeFilterUniv = () => {
    setFilterUnivModalStatus(false);
  };

  // Get filterd values
  const getSouceTypeValues = (data: string[]) => {
    dispatch(updateSourceType(data));
  };

  // Get category values
  const getCategoryTypeValues = (data: string[]) => {};

  // Get subject values
  const getSubjectTypeValues = (data: string[]) => {
    dispatch(updateSubject(data));
  };

  // Get Author values
  const getAuthorTypeValues = (data: string[]) => {
    dispatch(updateSourceType(data));
    logPackagesFiltersageData(82, packageDetails);
  };
  // Get datatype values
  const getDataTypeValues = (data: string[]) => {
    logPackagesFiltersageData(80);
    dispatch(updateJournalDataType(data));
  };
  // Get speaker values
  const getSpeakerTypeValues = (data: string[]) => {
    dispatch(updateSubject(data));
    logPackagesFiltersageData(81, packageDetails);
  };

  // Get research values
  const getResearchTypeValues = (data: string[]) => {
    dispatch(updateResearch(data));
  };

  // Get journal values
  const getJournalTypeValues = (data: string[]) => {
    dispatch(updateJournal(data));
  };

  // Get ranking values
  const getRankingTypeValues = (data: string[]) => {
    dispatch(updateJournalRank(data));
    logPackagesFiltersageData(80, packageDetails);
  };

  // Get cop values
  const getCopTypeValues = (data: string[]) => {
    dispatch(updateCountryOfPublication(data));
    logPackagesFiltersageData(79, packageDetails);
  };

  // Get cop values
  const getCopaTypeValues = (data: string[]) => {
    dispatch(updateCountryOfPublishingAuthor(data));
  };

  // Get publisher values
  const getPublisherTypeValues = (data: string[]) => {
    dispatch(updatePublisher(data));
  };

  // function apply filter
  async function applyFilter() {
    // if (!searchTerm) return;
    setTriggerCount((prev) => prev + 1);

    goToTop();
  }

  async function applySearch() {
    // dispatch(updateLoadingState(true));
    // generatedFilterString();
    let returnData = generatedFilterString();
    setFilters(returnData);
    goToTop();
    // let data = await search(searchReducer, selectedFilters, dispatch);
    // dispatch(updateSearchResults(data));
    // dispatch(updateLoadingState(false));
  }

  // clear all filters
  function handleClearAllFilters() {
    dispatch(clearAllFilters());
    setTriggerCount((prev) => prev + 1);
  }

  // Handle independent filter source index
  function handleSourceIndex() {
    dispatch(updateSourceIndex(!sourceIndex));
    setTriggerCount((prev) => prev + 1);
  }

  function handleOpenAccess() {
    dispatch(updateCurrentUpdate(!openAccess));
    setTriggerCount((prev) => prev + 1);
    logPackagesFiltersageData(83, packageDetails);
  }

  function handleRetractedArticles() {
    dispatch(updateRetractedArticle(!retractedArticle));
    setTriggerCount((prev) => prev + 1);
  }

  function handleDateSet() {
    dispatch(updateDateset(!datasetAvailability));
    setTriggerCount((prev) => prev + 1);
  }
  const updateFilters: any = useSelector(
    (state: any) => state.browseFilterSlice,
  );

  const l2Subjects = updateFilters?.subject.filter(
    (val: any) => val.isSelected,
  );

  const selected_l2_subjects = l2Subjects?.map((val: any) => val.val);

  const l3Subjects: any = selectedFilters?.subject
    ?.filter((subject: any) => !subject.isSelected)
    .flatMap((subject: any) => subject.subjects_name_l3.buckets)
    .filter((bucket: any) => bucket.isChecked);

  const selected_l3_subjects = l3Subjects?.map((val: any) => val.val);

  function generatedFilterString() {
    const ranking = updateFilters?.journalRank?.length
      ? "&" +
        objectToQueryString({
          filter_metrix:
            '("' + updateFilters?.journalRank.join('" OR "') + '")',
        })
      : "";
    const publisherCountry = updateFilters?.countryOfPublication?.length
      ? "&" +
        objectToQueryString({
          primary_publisher_country:
            '("' + updateFilters?.countryOfPublication?.join('" OR "') + '")',
        })
      : "";

    const source_index = updateFilters?.sourceType?.length
      ? "&" +
        objectToQueryString({
          fq__resource_source_index:
            '("' + updateFilters?.sourceType?.join('" OR "') + '")',
        })
      : "";

    let resourceType = "";

    if (updateFilters?.dataType?.includes("Journals")) {
      resourceType = "(1 OR 2)";
    }

    if (updateFilters?.dataType?.includes("Magazines")) {
      resourceType = resourceType ? "(1 OR 2 OR 5)" : "(5)";
    }

    if (updateFilters?.dataType?.includes("Trade / Technical Periodicals")) {
      resourceType = resourceType ? "(1 OR 2 OR 5)" : "(5)";
    }

    const dataType = resourceType
      ? "&" +
        objectToQueryString({
          resource_type: resourceType,
        })
      : "";

    // const subjects = updateFilters?.subject?.length
    //   ? "&" +
    //     objectToQueryString({
    //       subjects_name_l3:
    //         '("' + updateFilters?.subject?.join('" OR "') + '")',
    //     })
    //   : "";
    const subjects =
      selected_l2_subjects.length > 0 && selected_l3_subjects.length > 0
        ? "&" +
          objectToQueryString({
            "fq__(subjects_name_l2": encodeURIComponent(
              '("' +
                selected_l2_subjects.map((val: any) => val).join('" OR "') +
                '")',
            ),
          }) +
          " OR " +
          objectToQueryString({
            subjects_name_l3: encodeURIComponent(
              '("' +
                selected_l3_subjects.map((val: any) => val).join('" OR "') +
                '")' +
                ")",
            ),
          })
        : selected_l2_subjects.length > 0
          ? "&" +
            objectToQueryString({
              fq__subjects_name_l2: encodeURIComponent(
                '("' +
                  selected_l2_subjects.map((val: any) => val).join('" OR "') +
                  '")',
              ),
            })
          : selected_l3_subjects.length > 0
            ? "&" +
              objectToQueryString({
                fq__subjects_name_l3: encodeURIComponent(
                  '("' +
                    selected_l3_subjects.map((val: any) => val).join('" OR "') +
                    '")',
                ),
              })
            : "";

    return publisherCountry + source_index + subjects + ranking + dataType;
  }

  return (
    <>
      <Box sx={webStyle.leftBox}>
        <Box sx={[webStyle.flexBox]}>
          <Typography
            sx={{
              alignSelf: "center",
              fontFamily: "Lora",
              fontWeight: 700,
              fontSize: "1.125rem",
            }}
          >
            Filters
          </Typography>
          <Button onClick={handleClearAllFilters}>Clear All</Button>
        </Box>

        {Array.isArray(jsonFacets?.data_type?.buckets) &&
        jsonFacets?.data_type?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Document Type
              </Typography>
              <Button onClick={() => setSourceTypeModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {/* <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
          <Typography sx={{ fontSize: "0.875rem", alignSelf: "center" }}>
            Category
          </Typography>
          <Button onClick={() => setFilterCategoryModalStatus(true)}>
            <ControlPointIcon></ControlPointIcon>
          </Button>
        </Box>
        <Box>
          {categoryValue.length
            ? categoryValue?.map((data) => (
                <Stack direction={"row"} alignItems="center">
                  <Button
                    onClick={() =>
                      removeFilter(data, categoryValue, setCategoryValue)
                    }
                  >
                    <CloseIcon sx={{ color: "#6B7280" }} />
                  </Button>
                  <Typography>{data}</Typography>
                </Stack>
              ))
            : null}
        </Box>
        <Divider /> */}

        {/* {searchResult?.subjects_name_l3.length !== 0 ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Subject
              </Typography>
              <Button onClick={() => setFilterSubjectModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null} */}

        {searchResult?.subjects_name_l3?.length !== 0 ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Subject
              </Typography>
              <Button onClick={() => setFilterL2SubjectModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.authors_tk?.buckets) &&
        jsonFacets?.authors_tk?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Author
              </Typography>
              <Button onClick={() => setFilterAuthorModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.speakers?.buckets) &&
        jsonFacets?.speakers?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Speaker
              </Typography>
              <Button onClick={() => setFilterSpeakerModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.guide_name_tk?.buckets) &&
        jsonFacets?.guide_name_tk?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                {/* Guides (Ph.D Theses) */}
                Research Guides
              </Typography>
              <Button onClick={() => setFilterResearchModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.journal_name?.buckets) &&
        jsonFacets?.journal_name?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Journal
              </Typography>
              <Button onClick={() => setFilterJournalModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {searchResult?.filter_metrix?.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Ranking
              </Typography>
              <Button onClick={() => setFilterRankingModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {/* <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
          <Typography sx={{ fontSize: "0.875rem", alignSelf: "center" }}>
            Year(3345)
          </Typography>
          <Button onClick={() => setFilterYearModalStatus(true)}>
            <ControlPointIcon></ControlPointIcon>
          </Button>
        </Box>
        <Box>
          {year.length
            ? year?.map((data) => (
                <Stack direction={"row"} alignItems="center">
                  <Button onClick={() => removeFilter(data, year, setYear)}>
                    <CloseIcon sx={{ color: "#6B7280" }} />
                  </Button>
                  <Typography>{data}</Typography>
                </Stack>
              ))
            : null}
        </Box>
        <Divider /> */}

        {searchResult?.resource_source_index.length !== 0 ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Source Index
              </Typography>
              <Button onClick={() => setFilterAuthorModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : (
          ""
        )}

        {searchResult?.primary_publisher_country.length !== 0 ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Publication Country
              </Typography>
              <Button onClick={() => setFilterCountryModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.author_country_name?.buckets) &&
        jsonFacets?.author_country_name?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                {/* Country of Publishing Author */}
                Author Country
              </Typography>
              <Button onClick={() => setCopaModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : (
          ""
        )}

        {Array.isArray(jsonFacets?.publisher_name?.buckets) &&
        jsonFacets?.publisher_name?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Publishers
              </Typography>
              <Button onClick={() => setFilterPublisherModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {Array.isArray(jsonFacets?.author_address?.buckets) &&
        jsonFacets?.author_address?.buckets.length ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Institution
              </Typography>
              <Button onClick={() => setFilterUnivModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        {dataTypesOfJournalDetails?.buckets?.length > 0 ? (
          <>
            <Box sx={[webStyle.flexBox]} mt={"2%"} mb={"2%"}>
              <Typography
                sx={{ fontSize: "0.875rem", alignSelf: "center" }}
                fontFamily={"Helvetica Neue"}
              >
                Publication Type
              </Typography>
              <Button onClick={() => setFilterDataTypeModalStatus(true)}>
                <ControlPointIcon></ControlPointIcon>
              </Button>
            </Box>
            <Divider />
          </>
        ) : null}

        <Box>
          {/* for DF-2321 */}
          {/* <Typography
            mt={2}
            mb={2}
            sx={{
              fontSize: "0.875rem",
              alignSelf: "center",
              fontFamily: "Helvetica Neue",
              fontWeight: "600",
            }}
          >
            Independent Filters (1)
          </Typography>
          <Divider /> */}

          <FormGroup>
            {from !== "publisherONOS" && (
              <FormControlLabel
                control={<Checkbox checked={openAccess} />}
                label="By current Update"
                onChange={handleOpenAccess}
                componentsProps={{
                  typography: {
                    fontFamily: "Helvetica Neue",
                    fontWeight: "500",
                    fontSize: "14px",
                  },
                }}
              />
            )}
            {/* <FormControlLabel
              control={<Checkbox />}
              label="Web of Science"
              onChange={handleRetractedArticles}
              sx={{ fontFamily: "Helvetica Neue", fontWeight: "500" }}
              componentsProps={{
                typography: {
                  fontFamily: "Helvetica Neue",
                  fontWeight: "500",
                  fontSize: "14px",
                },
              }}
            /> */}
            {/* <FormControlLabel
              control={<Checkbox />}
              label="DOAJ"
              onChange={handleDateSet}
              sx={{ fontFamily: "Helvetica Neue", fontWeight: "500" }}
              componentsProps={{
                typography: {
                  fontFamily: "Helvetica Neue",
                  fontWeight: "500",
                  fontSize: "14px",
                },
              }}
            /> */}
          </FormGroup>
        </Box>
      </Box>

      {/* Filter popups */}
      {/* <SourceType
        isOpen={sourceTypeModalStatus}
        handleClose={handleChangeSouceType}
        modalName="Filter Source Type"
        getFilterdValues={getSouceTypeValues}
        filterValues={jsonFacets?.data_type?.buckets}
        applyFilter={applyFilter}
        appliedFilterValues={selectedFilters?.sourceType}
      /> */}

      {/* <FilterCategory
        isOpen={filterCategoryModalStatus}
        handleClose={handleChangeFilterCategory}
        modalName="Filter Category"
        getFilterdValues={getCategoryTypeValues}
        filterValues={jsonFacets?.openaccess_type?.buckets}
      /> */}
      {/* <FilterCountryOfPublication
        isOpen={filterSubjectModalStatus}
        handleClose={handleChangeFilterSubject}
        modalName="Filter Subject"
        getFilterdValues={getSubjectTypeValues}
        filterData={jsonFacets?.subjects_name_l3?.buckets}
        applyFilter={applyFilter}
        placeholderName="subject"
        appliedFilterValues={selectedFilters?.subject}
        facetKey="subjects_name_l3"
      /> */}
      {/* <FilterSubject
        isOpen={filterSubjectModalStatus}
        handleClose={handleChangeFilterSubject}
        modalName="Filter Subject"
        getFilterdValues={getSubjectTypeValues}
        filterData={jsonFacets?.subjects_name_l3?.buckets}
        applyFilter={applyFilter}
        placeholderName="subject"
        appliedFilterValues={selectedFilters?.subject}
        facetKey="subjects_name_l3"
      /> */}
      {/* <FilterYear
        isOpen={filterYearModalStatus}
        handleClose={handleChangeFilterYear}
        modalName="Filter Year`"
        getFilterdValues={getYearTypeValues}
        yearData={yearFromData}
      /> */}

      <FilterSubjectOfBrowser
        setFilters={setFilters}
        isOpen={filterSubjectModalStatus}
        handleClose={handleChangeFilterSubject}
        modalName="Filter Subject"
        getFilterdValues={getSpeakerTypeValues}
        filterData={searchResult?.subjects_name_l3}
        applyFilter={applyFilter}
        placeholderName="Subject name"
        appliedFilterValues={selectedFilters?.subject}
        facetKey="subjects_name_l3"
      />

      <FilterL2SubjectOfBrowser
        setFilters={setFilters}
        isOpen={filterL2SubjectModalStatus}
        handleClose={handleChangeFilterL2Subject}
        modalName="Filter Subject"
        getFilterdValues={getSpeakerTypeValues}
        filterData={subject_l2_package_searchResult?.buckets}
        applyFilter={applyFilter}
        placeholderName="Subject name"
        appliedFilterValues={selectedFilters?.subject}
        facetKey="subjects_name_l3"
      />

      <FilterCountry
        setFilters={setFilters}
        isOpen={filterCountryModalStatus}
        handleClose={handleChangeFilterCountry}
        modalName="Filter Publication Country"
        getFilterdValues={getCopTypeValues}
        filterData={searchResult?.primary_publisher_country}
        applyFilter={applyFilter}
        placeholderName="Publication Country name"
        appliedFilterValues={selectedFilters?.countryOfPublication}
        facetKey="primary_publisher_country"
      />

      <FilterRanking
        setFilters={setFilters}
        isOpen={filterRankingModalStatus}
        handleClose={handleChangeFilterRanking}
        modalName="Filter Journal Ranking"
        getFilterdValues={getRankingTypeValues}
        filterValues={searchResult?.filter_metrix}
        applyFilter={applyFilter}
        appliedFilterValues={selectedFilters?.journalRank}
      />

      <FilterAuthor
        setFilters={setFilters}
        isOpen={filterAuthorModalStatus}
        handleClose={handleChangeFilterAuthor}
        modalName="Filter Source Index"
        getFilterdValues={getAuthorTypeValues}
        filterValues={searchResult?.resource_source_index}
        applyFilter={applyFilter}
        // placeholderName="resource index"
        appliedFilterValues={selectedFilters?.sourceType}
        // facetKey="resource_source_index"
      />

      <FilterDataTypesOfJournalDetails
        setFilters={setFilters}
        isOpen={filterDataTypeModalStatus}
        handleClose={handleChangeFilterDataType}
        modalName="Filter Publication Type"
        getFilterdValues={getDataTypeValues}
        filterValues={mergedData}
        applyFilter={applyFilter}
        // placeholderName="resource index"
        appliedFilterValues={selectedFilters?.dataType}
        // facetKey="resource_source_index"
      />
    </>
  );
};

export default SearchFilterComponentOfJournalDetails;

const webStyle = {
  // flexBox: {
  //   display: "flex",
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  // },
  // leftBox: {
  //   width: "92%",
  //   maxWidth: "340px",
  //   backgroundColor: Colors.white,
  //   borderWidth: 1,
  //   borderColor: Colors.gray_1000,
  //   borderRadius: 2,
  //   marginTop: "3%",
  //   padding: "7%",
  //   boxShadow: 1,
  // },
  // titleHeader: {
  //   fontFamily: "Helvetica Neue",
  //   fontWeight: 700,
  //   textAlign: "left",
  //   fontSize: "1.125rem",
  // },
  flexBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  leftBox: {
    width: "92%",
    maxWidth: "340px",
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.gray_1000,
    borderRadius: 2,
    marginTop: "3%",
    padding: "7%",
    boxShadow: 1,
  },
  titleHeader: {
    fontFamily: "Lora",
    fontWeight: 700,
    textAlign: "left",
    fontSize: "1.125rem",
  },
};
